"use client"

import { VisuallyHidden as VisuallyHiddenPrimitive } from "radix-ui"

export const VisuallyHidden = VisuallyHiddenPrimitive.Root
